import { createSelector } from '@ngrx/store';
import { denormalize } from 'normalizr';
import {
  ByKey,
  createListStateIdsSelector,
  createListStateParamsSelector,
  createStateErrorsSelector,
  createStateLoadingSelector,
  createStateSuccessSelector,
  IdType,
  ListState
} from '@industi/ngx-common';
import { EntityTypes } from '../../../entity/entity-types';
import { createEntitiesSelector } from '../../../entity/entities.reducer';
import { createSymfonyTotalCountSelector } from '../../../symfony/list/selectors/list.selectors';
import { Entities } from '../../../entity/entities';
import { EntityState } from '../../../entity/entity.reducer';
import { getDictionaryOperationListState } from '../operation.reducer';
import { DictionaryOperation } from '../models/operation';

const createState = (id: IdType) => createSelector(
  getDictionaryOperationListState,
  (state: ByKey<ListState>) => state && state[id]
);

const createStateByContext = (id: IdType) => createListStateIdsSelector(createState(id));

export const createDictionaryOperationListData = (id: IdType) => createSelector(
  createStateByContext(id),
  createEntitiesSelector([
    EntityTypes.operation
  ]),
  (
    ids: IdType[],
    entities: EntityState
  ) => denormalize(ids, [Entities[EntityTypes.operation]], entities) as DictionaryOperation[]
);

export const createDictionaryOperationListLoading = (id: IdType) => createStateLoadingSelector(
  createState(id));

export const createDictionaryOperationListSuccess = (id: IdType) => createStateSuccessSelector(
  createState(id));

export const createDictionaryOperationListErrors = (id: IdType) => createStateErrorsSelector(
  createState(id));

export const createDictionaryOperationListTotalCount = (id: IdType) => createSymfonyTotalCountSelector(
  createState(id));

export const createDictionaryOperationListParams = (id: IdType) => createListStateParamsSelector(
  createState(id));
